// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__2bUZ-","backgroundBox":"style_backgroundBox__l7S0n","title":"style_title__1-E0a","addIcon":"style_addIcon__1jZ5G","boxContent":"style_boxContent__OUT8B"};